<div class="layout" [ngClass]="{ 'layout--rtl': direction === 'rtl' }">
  <cmx-header *ngIf="version !== 3" class="header" [ngClass]="{ 'cmx-header__modal-open': isModalOpen }">
    <ng-content select="[cmx-logo]"></ng-content>
  </cmx-header>
  <div class="layout__wrapper">
    <cmx-header *ngIf="version === 3" [class]="'header-v3'" [ngClass]="{ 'cmx-header__modal-open': isModalOpen }">
      <ng-content select="[cmx-logo]"></ng-content>
    </cmx-header>
    <!-- MOBILE SIDEBAR V3 -->
    <cmx-sidebar
      *ngIf="isMobile && version === 3"
      [entityName]="entityName"
      [entityId]="entityId"
      [employeeVariant]="employeeVariant"
      class="nav nav-v{{ version }}-sidenav-mobile "
    ></cmx-sidebar>
    <!-- MOBILE SIDEBAR START-->
    <div *ngIf="isMobile && version !== 3 && isMobileMenuOpen" [@mobileMenu]="direction" class="cmx-navbar-static">
      <cmx-sidebar class="nav nav-v{{ version }}"></cmx-sidebar>
      <div (click)="toggleMobileMenu()" class="cmx-navbar-static__overlay">
        <div
          class="cmx-navbar-static__overlay__icon"
          [ngClass]="{ 'cmx-navbar-static__overlay__icon--rtl': direction === 'rtl' }"
        >
          <span class="cmx-icon-close"></span>
        </div>
      </div>
    </div>
    <!-- MOBILE SIDEBAR END-->
    <cmx-sidebar
      *ngIf="!isMobile"
      (isCollapsedEvent)="isCollapsedSideNav($event)"
      class="nav nav-v{{ version }}"
      [class]="version === 3 ? 'sidenav-v3' : ''"
      [entityName]="entityName"
      [entityId]="entityId"
      [employeeVariant]="employeeVariant"
      >Sidebar</cmx-sidebar
    >
    <section
      class="center"
      [class]="version === 3 ? (isCollapsed ? 'collapsed' : 'open') + ' section-content' : ''"
      [class.center--collapsed]="!isMobile && version !== 3 && isCollapsed"
      [class.center--expanded]="!isMobile && version !== 3 && !isCollapsed"
    >
      <div
        [style.width.%]="loader"
        class="cmx-sub-nav-loader"
        [class]="version === 3 ? 'loader-v3 cmx-sub-nav-loader' : 'cmx-sub-nav-loader'"
      ></div>
      <cmx-mobile-lang-selector *ngIf="isMobile && isMobileLangSelectorOpen"></cmx-mobile-lang-selector>
      <cmx-mobile-entity-selector *ngIf="isMobile && isMobileEntitySelectorOpen"></cmx-mobile-entity-selector>
      <cmx-mobile-app-selector *ngIf="isMobile && isMobileAppSelectorOpen"></cmx-mobile-app-selector>
      <div class="content">
        <ng-content
          *ngIf="!isMobile || (!isMobileEntitySelectorOpen && !isMobileLangSelectorOpen && !isMobileAppSelectorOpen)"
        ></ng-content>
      </div>
    </section>
  </div>
  <cmx-footer *ngIf="!isMobile" class="footer"> </cmx-footer>
</div>
